module.exports = __webpack_public_path__ + "img/not-anonymous-icon.25262fc8.svg";